export default "__VITE_ASSET__H0Q$Jtj0__"